import { getApp, getScreen } from '../../ums/utils';
export const getTrackingDataFromUpgradeConfig = upgradeConfig => {
  const app = getApp();
  const screen = getScreen();
  return {
    app,
    screen,
    uniqueId: upgradeConfig.upgradeKey
  };
};